export default "__VITE_ASSET__9$lYpcCf__"